import React from 'react'
import logoImgSrc1 from '../../../assets/img/company-logo-horizontal.png'
import logoImgSrc2 from '../../../assets/img/company-logo.png'

export default ({ title = 'Company Logo', className = '', orientation = 'horizontal' }) => {
  if (orientation === 'horizontal') {
    return <img style={{ width: '150px' }} src={logoImgSrc1} alt={title} />
  } else {
    return <img style={{ width: '250px' }} src={logoImgSrc2} alt={title} />
  }
}



// WEBPACK FOOTER //
// ./src/component/_presentational/icon/CompanyLogo.jsx